import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Webhook } from 'dashboard/models/webhook';
import { setWebhook } from 'dashboard/redux/slices/webhook';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export const loadWebhook = (id: string) => {
  return async (dispatch: Dispatch) => {
    const webhookResponse = await SessionClientDashboard.getResource<Webhook>(
      ApiEndpoint.Webhook,
      id,
    );

    const webhook = webhookResponse.data;

    dispatch(setWebhook(webhook));
  };
};

export const updateWebhook = (
  id: string,
  attributes: Partial<Webhook['attributes']>,
  meta: { 'password-confirmation': string },
) => {
  return async () => {
    const updateWebhookResponse = await SessionClientDashboard.updateResource<Webhook>(
      {
        type: ApiModel.Webhook as const,
        id: id,
        attributes: {
          url: attributes['url'],
          'api-version': attributes['api-version'],
          'api-key-inflection': attributes['api-key-inflection'],
          'api-attributes-blocklist': attributes['api-attributes-blocklist'],
          'included-blocklist': attributes['included-blocklist'],
          'relationship-blocklist': attributes['relationship-blocklist'],
          'enabled-events': attributes['enabled-events'],
          'payload-filter': attributes['payload-filter'],
          'custom-http-headers': attributes['custom-http-headers'],
          'file-access-token-expires-in': attributes['file-access-token-expires-in'],
        },
      },
      {
        meta: {
          'password-confirmation': meta['password-confirmation'],
        },
      },
    );

    return updateWebhookResponse;
  };
};

export const rotateWebhookSecret = (id: string, meta: { 'password-confirmation': string }) => {
  return async () => {
    const rotateWebhookSecretResponse = await SessionClientDashboard.postResourceAction<Webhook>(
      {
        type: ApiModel.Webhook as const,
        id: id,
      },
      'rotate-secret',
      {
        meta: {
          'password-confirmation': meta['password-confirmation'],
        },
      },
    );

    return rotateWebhookSecretResponse;
  };
};

export const enableWebhook = (id: string, meta: { 'password-confirmation': string }) => {
  return async () => {
    const enableWebhookResponse = await SessionClientDashboard.postResourceAction<Webhook>(
      {
        type: ApiModel.Webhook as const,
        id: id,
      },
      'enable',
      {
        meta: {
          'password-confirmation': meta['password-confirmation'],
        },
      },
    );

    return enableWebhookResponse;
  };
};

export const disableWebhook = (id: string, meta: { 'password-confirmation': string }) => {
  return async () => {
    const disableWebhookResponse = await SessionClientDashboard.postResourceAction<Webhook>(
      {
        type: ApiModel.Webhook as const,
        id: id,
      },
      'disable',
      {
        meta: {
          'password-confirmation': meta['password-confirmation'],
        },
      },
    );

    return disableWebhookResponse;
  };
};

export const archiveWebhook = (id: string, meta: { 'password-confirmation': string }) => {
  return async () => {
    const archiveWebhookResponse = await SessionClientDashboard.postResourceAction<Webhook>(
      {
        type: ApiModel.Webhook as const,
        id: id,
      },
      'archive',
      {
        meta: {
          'password-confirmation': meta['password-confirmation'],
        },
      },
    );

    return archiveWebhookResponse;
  };
};
